import React, { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../common/Loader';
import { Container } from 'react-bootstrap';
import MetaData from '../MetaData';
import SectionHeading from '../common/SectionHeading';
import { clearErrors, deleteOrder, getAllOrders } from '../../redux/actions/orderActions';
import { BsFillTrashFill, BsFillPencilFill } from 'react-icons/bs';
import Table from 'react-bootstrap/Table';
import { useNavigate, Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Row, Col } from 'react-bootstrap';
import { DELETE_ORDER_RESET } from '../../redux/constants/orderConstants';

const OrderList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, orders, error } = useSelector((state) => state.allOrders);
    const { isDeleted, error: deleteError } = useSelector((state) => state.order);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (deleteError) {
            toast.error(deleteError);
            dispatch(clearErrors());
        }

        if (isDeleted) {
            toast.success('Order deleted successfully');
            dispatch({ type: DELETE_ORDER_RESET });
            navigate('/admin/orders');
        }

        dispatch(getAllOrders());
    }, [error, deleteError, isDeleted]);

    const handleDeleteOrder = (id) => {
        dispatch(deleteOrder(id));
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={`All Orders - Admin`} />
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <SectionHeading heading={'All Orders'} />
                    <Row>
                        <Col md={3}>
                            <Sidebar />
                        </Col>
                        <Col md={9}>
                            <div className='scrollableTable'>
                                <Table striped bordered hover className='commonTable'>
                                    <thead>
                                        <tr>
                                            <th>OrderID</th>
                                            <th>Status</th>
                                            <th>Items Qty</th>
                                            <th>Amount</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders &&
                                            orders.length > 0 &&
                                            orders.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item._id}</td>
                                                    <td
                                                        className={`text-uppercase
                                                            ${
                                                                item.orderStatus.toUpperCase() ===
                                                                'DELIVERED'
                                                                    ? 'text-success'
                                                                    : item.orderStatus.toUpperCase() ===
                                                                      'CANCELLED'
                                                                    ? 'text-danger'
                                                                    : item.orderStatus.toUpperCase() ===
                                                                      'SHIPPED'
                                                                    ? 'text-info'
                                                                    : 'text-warning'
                                                            }
                                                        `}
                                                    >
                                                        {item.orderStatus}
                                                    </td>
                                                    <td>{item.orderItems.length}</td>
                                                    <td>{item.totalPrice}</td>
                                                    <td>
                                                        <Link to={`/admin/order/${item._id}`}>
                                                            <BsFillPencilFill />
                                                        </Link>
                                                        <button
                                                            className='common-btn'
                                                            onClick={() =>
                                                                handleDeleteOrder(item._id)
                                                            }
                                                        >
                                                            <BsFillTrashFill />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default OrderList;
